export default __webpack_public_path__ + "static/media/logo.0410be54.png";